<template>
    <v-app>
        <v-layout>
            <v-select v-model="select"
                    :items="items"
                    item-text="text"
                    item-value="sort"
                    return-object
                    single-line
                ></v-select>
        </v-layout>
    </v-app>
</template>

<script>
    export default {
        data: () => ({
            select: {text: null, sort: $cookies.get('dashboardSort')},
            items: [
                { text: 'Сортировать по дате окончания', sort: 'end-date' },
                { text: 'Сортировать по дате начала', sort: 'start-date' },
                { text: 'Сортировать по имени клиента', sort: 'name' },
                { text: 'Сортировать по марке автомобиля', sort: 'car' },
                { text: 'Сортировать по страховой компании', sort: 'company' },
                { text: 'Сортировать по статусу', sort: 'status' }
            ],
        }),

        created: function () {
            let selectedItem = this.items.filter((item) => {
                return item.sort === $cookies.get('dashboardSort');
            }).pop();

            this.select = selectedItem ? selectedItem : this.items[0];
        },

        watch: {
            select: function (val, oldVal) {
                if (val.sort !== oldVal.sort) {
                    $cookies.set('dashboardSort', val.sort);
                    window.location.reload();
                }
            },
        },
    }
</script>


<style scoped>
    /deep/ .v-list__tile__title {
        color: #000;
    }

    /deep/ .v-list__tile--active .v-list__tile__title {
        color: #00ba57;
    }

    /deep/ input {
        padding: 0;
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/DashboardSort.vue